import { isNotDefined } from '@/utils/assertions';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorIcon, type HandledFilterModel, formatters } from './filterFormatters.tsx';

type Props = {
  identifier: string;
  columnId: string;
  filterModel: HandledFilterModel;
  onClearRequested: (columnId: string) => void;
};

export const FilterBadge = ({ columnId, identifier, filterModel, onClearRequested }: Props) => {
  const handleClose = useCallback(() => onClearRequested(columnId), [onClearRequested, columnId]);

  if (isNotDefined(filterModel?.filterType) || isNotDefined(formatters[filterModel.filterType])) {
    return <ErrorIcon />;
  }

  return (
    <span
      key={columnId}
      className="badge badge-discreet-info badge-md badge-dismissible"
      data-e2e={`${identifier}.filter.${columnId}`}
    >
      <button type="button" className="btn" onClick={handleClose}>
        <em className="icon">close</em>
      </button>

      <div>
        <FormattedMessage id={`${identifier}.table.${columnId}`} />
        &nbsp;<span>{formatters[filterModel.filterType](filterModel)}</span>
      </div>
    </span>
  );
};
